/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An environment variable a package declares its install requires
 */
export type ExternalMCPPackageEnvironmentVariable = {
  /**
   * The publisher's explanation of the variable. Untrusted text.
   */
  description?: string | undefined;
  /**
   * Whether an install cannot proceed without it
   */
  isRequired: boolean;
  /**
   * Whether the publisher marked the value sensitive
   */
  isSecret: boolean;
  /**
   * Variable name the install must populate
   */
  name: string;
};

/** @internal */
export const ExternalMCPPackageEnvironmentVariable$inboundSchema: z.ZodMiniType<
  ExternalMCPPackageEnvironmentVariable,
  unknown
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    is_required: z.boolean(),
    is_secret: z.boolean(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "is_required": "isRequired",
      "is_secret": "isSecret",
    });
  }),
);

export function externalMCPPackageEnvironmentVariableFromJSON(
  jsonString: string,
): SafeParseResult<ExternalMCPPackageEnvironmentVariable, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ExternalMCPPackageEnvironmentVariable$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExternalMCPPackageEnvironmentVariable' from JSON`,
  );
}
